import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserManagementService } from '../user-management/user-management.service';
import { environment } from '../../environments/environment';
import { UserRoleService } from 'src/app/shared/user-role.service';

@Component({
    selector: 'app-main-page',
    templateUrl: './main-page.component.html',
    styleUrls: ['./main-page.component.css'],
    standalone: false
})
export class MainPageComponent implements OnInit {

  userDetail: any;
  private storage = environment.storage;
  userRle: number;
  // admin_id: number | null = null;
  visitedUserManagementSites = false;
  constructor(private router: Router, private userService: UserManagementService, private userRoleService: UserRoleService) {
  }

  ngOnInit(): void {
    this.userDetail = this.userService.getUserDetail();

    // Initialize the user's role in the UserRoleService
    if (this.userDetail?.role && this.userRoleService.getUserRole() == null) {
      this.userRoleService.initializeUserRole(this.userDetail.role);
    }

    // Subscribe to role changes
    this.userRoleService.userRole$.subscribe((role) => {
      console.log('MainPageComponent userRle updated:', role);
      this.userRle = role;
      console.log('Navigation updated for role:', this.userRle);
    });

    this.visitedUserManagementSites = sessionStorage.getItem('visitedUserManagementSites') === 'true';
  }

  // fetchAdminId() {
  //   this.userService.getPlants().subscribe((response: any) => {
  //     if (response.status === 1) {
  //       const plantWithAdmin = response.plants.find((plant: any) => plant.admin_user_id);
  //       this.admin_id = plantWithAdmin ? plantWithAdmin.admin_user_id : null;
  //       console.log('Admin ID:', this.admin_id);
  //     }
  //   });
  // }

  get currentUrl(){
    return this.router.url;
  }

  // get userRle() {
  //   if(this.userDetail?.role==14 && this.currentUrl=='/'){
  //     return this.userDetail?.role;
  // }else if(this.userDetail?.role==14 && (this.currentUrl=='/reportlibrary/editreport/process' || this.currentUrl=='/reportlibrary/editreport/opex' || this.currentUrl=='/dashboard/opexdashboard')){
  //     return '';
  //   }else if(this.userDetail?.role==14 && this.currentUrl!='/'){
  //     return this.userDetail?.role;
  //   }else{
  //     return this.userDetail?.role;
  //   }
    
  // }

}
